module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('a', {
    attrs: {
      "id": "chapter04"
    }
  }), _vm._v("4")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AT THAT PRECISE MOMENT, SHERIFF")]), _vm._v("’"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("S DEPUTY BOBBY CROWNER WAS MAN")]), _vm._v("ning a speed trap over on the bypass. His cruiser sat tucked in behind a stand of mesquite with easy access to the northbound lanes. He had his radar gun trained to the south, aimed at the crest of a hill that gave him further cover. He felt like a hunter in a deer blind, waiting for a buck with a Boone and Crockett rack to come trotting into view.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Bobby? You there?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He leaned forward and took up the mike and thumbed the button. “Can’t think where else I’d be, Darlene.” The way he pronounced it, “can’t” rhymed with “ain’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“You been thinkin’ about what we talked about?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Bobby’s hand dropped to his side, and he looked off into the darkness. He couldn’t believe she was bringing this up over the county two-way. He thumbed the mike. “It’s a open network, Darlene. Lots of ears out there.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Just the other deputies.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“And folks with scanners.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“You been thinkin’ about it, or not?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Ain’t gonna do it, Darlene.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Come on, Bobby. You know the sheriff better than the rest of us.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I don’t know the man so well as to broach no subject of that nature.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“If I were him I’d like to know I was being talked about in such terms.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I don’t see there’s a thing to be done if a man is being talked about behind his back ’cept leave it be and hope people lose interest.” He released the button and sat listening. He could hear an engine in the distance, coming his way at a gallop. He thumbed the button once more. “Look, I got to go.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He replaced the mike and turned slightly to his left and adjusted the "), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _vm._v("radar gun. The hill at which it was pointed was backlit by a rapidly accruing brightness.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The big SUV topped the rise, and the radar gun read 93 in red numerals on the back.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Bobby pulled the radar gun down and cranked the engine. He switched on flashers and headlights just in time to catch the white Hummer in his high beams as it raced past. He fired out of his hiding place like a bullet on wheels.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He pulled behind the Hummer and started to close the distance. The Hummer’s brake lights flashed, and then a funny thing happened.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Hummer started pulling away.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Bobby floored the Impala, pushing his two hundred horses to their limit. The speedometer needle shot to the right, and with his off hand he slid his window up so he could hear himself think. Once the cab was tight he took the two-way mike in hand.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He thumbed the button. “Darlene, this is Bobby.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Come ahead on, Deputy Crowner.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I am in pursuit of a white Hummer out here on the bypass. I need you to run some tags for me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He read her the license plate number and replaced the handset. He already had a pretty fair notion what she’d turn up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("They were doing better than a hundred down a road that was blessedly empty save for the Hummer and him. Up ahead the Hummer took curves with an abandon that struck Bobby as a species of madness.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Around them all was darkness except what their high beams and the lightbar on Bobby’s cruiser lit up, and traveling at that speed it was simply a fluke that it caught his eye for an instant, something white sailing out of a back window just as they rounded the last curve before the bypass cloverleafed back into the main highway. He made a mental note to add that to his report.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Littering would set this jackass back yet another couple hundred bucks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The two-way squawked. “Yo, Bobby. Your Hummer is registered to Tyrone Daniels Enterprises.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“TD his own self.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Probably one of the kids or hangers-on.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“He’s got ’em both in abundance.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“He still runnin’?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Like a spotted-ass ape.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _vm._v("“You want backup? ’Nando is hanging out near the county line.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Yeah. Send him this way, if you would.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Bobby took the wheel with both hands again. Big turn coming up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Hummer took the exit from the bypass going full tilt, and as Bobby watched the laws of the universe reasserted themselves. First the big white vehicle went up on two wheels, and then it lost its purchase on the tarmac entirely and was wheels over roof and then upright and then over on its back again in a roll that only ended when it slammed upside-down into a stand of scrub oaks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Bobby pulled over to the side of the road and sat watching. No one emerged from the vehicle. He reached for the mike.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Darlene, this peckerwood just spun out over at the cloverleaf. He’s ass over elbows on the side of the road. You best better send out a couple ambulances.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“That’s a roger.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Bobby hit the button in the armrest, and the window slid down. He sat watching for signs of life. Hard to see with it as dark as it was. Even at this remove the smell of marijuana smoke reached him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He backed the cruiser up and spun the wheel to the left. He parked perpendicular to the highway with his headlights shining toward the wreckage. The air bags had deployed and obscured the occupants from better than a partial view.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In the distance sirens could be heard. The cavalry was en route.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He stepped out of his vehicle and approached the wreckage, hand resting on the butt of his sidearm.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a3386e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter04.vue
// module id = 93
// module chunks = 0